import {
    FETCH_DASHBOARD_STATS,
    FETCH_DASHBOARD_STATS_FAILURE,
    FETCH_DASHBOARD_STATS_SUCCESS,
} from 'store/actions/types';

export const fetchDashboardStats = (payload) => {
    return {
        type: FETCH_DASHBOARD_STATS,
        payload: payload,
    };
};

export const fetchDashboardStatsSuccess = (response) => {
    return {
        type: FETCH_DASHBOARD_STATS_SUCCESS,
        response: response,
    };
};

export const fetchDashboardStatsFailure = (error) => {
    return {
        type: FETCH_DASHBOARD_STATS_FAILURE,
        error: error,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/dashboardActions.js